import { motion } from 'framer-motion';
import { Home, Truck, Package, Sparkles, Trash2, KeyRound, ArrowUpRight } from 'lucide-react';
import { SERVICES } from '../data/site';
import Reveal, { ChapterLabel, EASE } from './Reveal';

const ICONS = { Home, Truck, Package, Sparkles, Trash2, KeyRound };

function ServiceCard({ service, index }) {
  const Icon = ICONS[service.icon] || Truck;
  return (
    <motion.article
      data-testid={`service-card-${service.id}`}
      initial={{ opacity: 0, y: 48 }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once: true, margin: '-60px' }}
      transition={{ duration: 0.8, delay: (index % 3) * 0.12, ease: EASE }}
      whileHover={{ y: -8 }}
      className="group relative overflow-hidden rounded-3xl border border-slate-200 bg-white shadow-sm transition-shadow duration-500 hover:shadow-2xl hover:shadow-navy/10"
    >
      <div className="relative h-52 overflow-hidden">
        <img
          src={service.image}
          alt={service.title}
          loading="lazy"
          className="h-full w-full object-cover transition-transform duration-700 ease-out group-hover:scale-110"
        />
        <div className="absolute inset-0 bg-gradient-to-t from-navy/60 to-transparent" />
        <span className="absolute left-5 top-5 font-display text-xs font-bold tracking-[0.3em] text-white/80">
          {String(index + 1).padStart(2, '0')}
        </span>
        <span className="absolute bottom-5 left-5 grid h-12 w-12 place-items-center rounded-2xl bg-brand text-white shadow-lg shadow-brand/40 transition-transform duration-500 group-hover:-rotate-6 group-hover:scale-110">
          <Icon className="h-5 w-5" />
        </span>
      </div>
      <div className="p-7">
        <h3 className="flex items-center justify-between font-display text-xl font-bold tracking-tight text-navy">
          {service.title}
          <ArrowUpRight className="h-5 w-5 text-slate-300 transition-all duration-300 group-hover:translate-x-1 group-hover:text-brand" />
        </h3>
        <p className="mt-3 text-sm leading-relaxed text-slate-500">{service.desc}</p>
      </div>
      <span className="absolute inset-x-0 bottom-0 h-1 origin-left scale-x-0 bg-brand transition-transform duration-500 group-hover:scale-x-100" />
    </motion.article>
  );
}

export default function Services() {
  return (
    <section id="leistungen" data-testid="services-section" className="bg-slate-50 py-24 md:py-32">
      <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8">
        <ChapterLabel index="01" title="Leistungen" />
        <div className="mt-8 flex flex-col justify-between gap-6 md:flex-row md:items-end">
          <Reveal delay={0.1}>
            <h2 className="max-w-2xl font-display text-3xl font-extrabold tracking-tight text-navy sm:text-4xl lg:text-5xl">
              Alles aus einer Hand –<br />
              <span className="text-brand">sechs Leistungen</span>, ein Ansprechpartner.
            </h2>
          </Reveal>
          <Reveal delay={0.2}>
            <p className="max-w-sm text-sm leading-relaxed text-slate-500 md:text-base">
              Vom einzelnen Möbelstück bis zur kompletten Haushaltsauflösung –
              zuverlässig, sauber und zum fairen Preis.
            </p>
          </Reveal>
        </div>

        <div className="mt-14 grid grid-cols-1 gap-6 md:grid-cols-2 lg:grid-cols-3 lg:gap-8">
          {SERVICES.map((s, i) => (
            <ServiceCard key={s.id} service={s} index={i} />
          ))}
        </div>
      </div>
    </section>
  );
}
